"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedSettingsProvider = void 0;
const React = __importStar(require("react"));
const named_settings_context_1 = require("./named-settings-context");
const named_settings_hook_1 = require("./named-settings-hook");
function NamedSettingsProvider({ children, url, adminPermission, }) {
    const { context } = (0, named_settings_hook_1.useNamedSettings)(url, adminPermission);
    return (React.createElement(named_settings_context_1.NamedSettingsContext.Provider, { value: context }, children));
}
exports.NamedSettingsProvider = NamedSettingsProvider;
//# sourceMappingURL=named-settings-provider.js.map